// extracted by mini-css-extract-plugin
export default {"flex_right":"TaxPayCompany_flex_right__pTI5v"};